export const ProfileFieldsMore = {
  bindings: {
    form: '<',
    member: '<',
    onUpdate: '&',
    isEditing: '<',
  },

  template: `
    <div class="row">
      <div class="col-md-4">
        <h5>More about you</h5>
        <p>Please tell us a bit more about yourself.</p>
      </div>
      <div class="col-md-8">
        <form-group-row>
          <form-group-left>
            <form-label for="profile.birthday">
              Date of birth
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-select-date
              form="$ctrl.form"
              name="profile.birthday"
              value="$ctrl.member.profile.birthday"
              year-start="-18"
              year-number="80"
              required="true"
              ng-show="$ctrl.isEditing"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{
                required: 'This is a required field.',
                date: 'Must be a valid date.'
              }">
            </form-select-date>
            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">
              {{ $ctrl.member.profile.birthday | date:'dd-MM-yyyy' }}
            </div>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="profile.gender">
              Gender
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-select
              form="$ctrl.form"
              name="profile.gender"
              value="$ctrl.member.profile.gender"
              required="true"
              ng-show="$ctrl.isEditing"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }">
              <option value="">-- Select --</option>
              <option value="F">Female</option>
              <option value="M">Male</option>
            </form-select>
            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">
              <span class="text-gray-900">
                {{ $ctrl.member.profile.gender === 'F' ? 'Female' : 'Male' }}
              </span>
            </div>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="startWeightInKg">
              Weight <span class="text-gray">(kg)<span>
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              type="number"
              form="$ctrl.form"
              name="startWeightInKg"
              value="$ctrl.member.startWeightInKg"
              minlength="1"
              required="true"
              ng-show="$ctrl.isEditing"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }"/>
            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">
              <span class="text-gray-900">
                {{ $ctrl.member.startWeightInKg }}
              </span>
            </div>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="profile.height">
              Height <span class="text-gray">(cm)<span>
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              type="number"
              form="$ctrl.form"
              name="profile.height"
              value="$ctrl.member.profile.height"
              minlength="1"
              required="true"
              ng-show="$ctrl.isEditing"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }"/>
            <div class="col-form-label pb-0" ng-hide="$ctrl.isEditing">
              <span class="text-gray-900">
                {{ $ctrl.member.profile.height }}
              </span>
            </div>
          </form-group-right>
        </form-group-row>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsMore.js